/**
 * Reference-document helpers shared across admin write paths.
 */

/**
 * Is a reference doc a Shopify VARIANT — i.e. does it hang off a parent?
 *
 * Mirrors watchlock's server-side helper exactly. The trim matters: a
 * whitespace-only `parentReferenceId` is not a real parent link, so the obvious
 * `!!parentReferenceId` is the WRONG test and would mark such a doc a variant,
 * hiding it from the (server-side filtered) admin listing forever.
 *
 * Takes `unknown` deliberately — call sites pass raw Firestore payload values,
 * `Partial<WatchReference>` fields, and `deleteField()` sentinels. Anything that
 * isn't a non-blank string is a parent/standalone.
 *
 * The `isVariant` flag this derives is what backs the parents-only listing
 * query; every admin write path sets it so the value is right on first write,
 * rather than relying on watchlock's self-healing trigger to correct it after
 * the fact.
 */
export function deriveIsVariant(parentReferenceId: unknown): boolean {
  return typeof parentReferenceId === 'string' && parentReferenceId.trim() !== '';
}
